import React, { useState } from 'react';
import { AppButton } from '../ui/AppButton';

/**
 * Monitoring Data Notarization event list and auto-notarization toggle.
 */
export const MDNStatusPanel = ({
  events,
  loading,
  onRefresh,
  onToggleSubscription,
}) => {
  const [buildingId, setBuildingId] = useState('');
  const [enabled, setEnabled] = useState(true);

  const submitSubscription = async () => {
    await onToggleSubscription({
      buildingId,
      sensorStreamId: 'default-stream',
      enabled,
    });
  };

  return (
    <section className="panel-card" aria-labelledby="mdn-status-title">
      <div className="panel-header">
        <h2 id="mdn-status-title">MDN Status</h2>
        <button type="button" onClick={onRefresh} className="px-3 py-1.5 rounded-card-sm text-[12px] font-semibold text-lb-body hover:text-lb-ink hover:bg-black/[0.04] transition-colors focus-ring outline-none">
          Refresh Events
        </button>
      </div>

      <div className="subscription-row">
        <input
          value={buildingId}
          onChange={(event) => setBuildingId(event.target.value)}
          placeholder="Building ID"
          aria-label="Building ID for auto-notarization"
          className="w-full px-3 py-2 rounded-card-sm bg-[#FAFAF7] border border-black/[0.06] text-[13px] text-lb-ink placeholder:text-lb-ghost focus:outline-none focus:border-lb-green-accent transition-colors"
        />
        <label>
          <input
            type="checkbox"
            checked={enabled}
            onChange={(event) => setEnabled(event.target.checked)}
          />
          Auto-notarisation
        </label>
        <AppButton type="button" variant="primary" onClick={submitSubscription}>
          Apply
        </AppButton>
      </div>

      {loading ? (
        <p>Loading events...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Building ID</th>
                <th>Batch Hash</th>
                <th>Block</th>
                <th>Explorer</th>
              </tr>
            </thead>
            <tbody>
              {(events || []).map((event, index) => (
                <tr key={`${event.batchHash}-${index}`}>
                  <td>{new Date(event.timestamp * 1000).toLocaleString()}</td>
                  <td>{event.buildingId}</td>
                  <td>{event.batchHash}</td>
                  <td>{event.blockNumber}</td>
                  <td>
                    {event.explorerLink ? (
                      <a href={event.explorerLink} target="_blank" rel="noreferrer">
                        View
                      </a>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
